<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-row class="justify-content-center">
      <b-col md="7" class="mt-3">
        <b-card-group>
          <b-card id="auftrag1" ref="el">
            <div slot="header"
                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
              <b-row style="margin-left: 0px; margin-right: 0px">
                <div>
              {{isAuftrag}} <strong>{{auftrag.beleg_ex}}</strong>
                </div>
                <b-col></b-col>
                <div>
                  Eingang: <strong>{{formateAnlageDate}}</strong>
                </div>
              </b-row>
            </div>
            <b-row style="border-bottom: 1px solid #ccc!important;">
              <b-col sm="5" style="padding-right: 0px;">
                <b-form-group
                    label="Auftraggeber:"
                    label-for="auftraggeber"
                >
                  <b-form-input
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                      disabled
                      id="auftraggeber"
                      type="text"
                      :placeholder="auftrag.auftraggeber"
                      v-model="auftrag.auftraggeber"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="1" style="padding-left: 8px;">
                <account-box v-if="this.einzel && this.einzel.pos_nr && this.einzel.pos_nr > '0200'" class="icon-2x" fillColor="#1B8EB7" :size="72" style="color: #3EA662;
    position: absolute;
    bottom: 1.20rem; cursor: pointer" @click="showAddressModal"></account-box>
              </b-col>
              <b-col sm="6">
                <b-form-group
                    label="Zieltermin an/bis:"
                    label-for="date"
                >
                  <datetime
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      :disabled="isEditMode"
                      v-model="aufgabe.datum"
                      input-class="form-control"
                      input-style="color: black;"
                      input-id="date"
                      :aria-placeholder="formateDate"
                      :phrases="datetimeConfig.phrases"
                      :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                      :min-datetime="datetimeConfig.minTime"></datetime>

                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="auftrag.art !== 'LS'">
              <b-col md="2" class="my-auto">
                <span>Auftragsgruppe</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAugr"
                              disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1"  v-if="auftrag.art !== 'LS'">
              <b-col md="2" class="my-auto">
                <span>Auftrag-Wo</span>
              </b-col>
              <b-col md="2" class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAuftragKey"
                              disabled></b-form-input>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="aufgabe.auftrag_wo"
                              disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span v-if="auftrag.art !== 'LS'">Auftrag-Was</span>
                <span v-else>Tourname</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="aufgabe.auftrag_was"
                              :disabled="!editMode"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2">
                <span>Hinweis</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-textarea
                    class="text-black"
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                    :disabled="!editMode"
                    type="text"
                    v-model="aufgabe.description"
                    :placeholder="aufgabe.description"
                    wrap="hard"
                    rows="3"
                    :max-rows="maxrows"
                >
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-1"  v-if="auftrag.art !== 'LS'">
              <b-col md="2" class="my-auto">
                <span>Maßnahme</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="aufgabe.massnahme"
                              :disabled="!editMode"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1"  v-if="auftrag.art !== 'LS'">
              <b-col md="2">
                <span>Material</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-textarea
                    class="text-black"
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                    :disabled="!editMode"
                    type="text"
                    v-model="aufgabe.materialtext"
                    :placeholder="aufgabe.materialtext"
                    wrap="hard"
                    rows="3"
                    :max-rows="maxrows"
                >
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span>Verantwortlich</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAusfDurch"
                              disabled></b-form-input>
              </b-col>
              <b-col md="2" class="my-auto"  v-if="editMode">
                <b-button variant="success"  class="btn-pill font-sm" @click="showChangeKostMigr = true">
                  Ändern
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span>Fertigstellungsart</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-select :options="close_automatic_select" id="close_automatic" :plain="true"
                               v-model="close_automatic"
                               :disabled="!editMode"
                               class="form-control text-black"></b-form-select>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span>Angenommen von:</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAhnehmerUser"
                              disabled></b-form-input>
              </b-col>
            </b-row>
          </b-card>
        </b-card-group>

        <b-card class="mt-2" v-if="auftrag.art === 'LS'">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Touraufgaben:</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm" @click="finishTourTasks" :disabled="!hasSelects" v-if="aufgabe.complete !== 10">
                  Fertigstellen
                </b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="margin-top: -1.25rem">
            <b-col style="padding: 0px">
              <tour-table ref="auftraegeTable"
                          :table-data="tourTasks"
                          :finished="aufgabe.complete === 10"
                          @finish-task="finishTourTask"
                          @select-changed="(selected) => {hasSelects = selected}"
              ></tour-table>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mt-2" v-if="auftrag.art !== 'LS'">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Aufgabenverteilung:</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm" @click="onChangeTodos" :disabled="aufgabe.complete === 10 || auftrag.rechnung || !canHandle">
                  Verteilung anpassen
                </b-button>
                <finish-icon v-if="aufgabe.complete !== 10 && !auftrag.rechnung && canHandle" title="" v-tooltip="'Fertigstellen'" :class="{'icon-1_5x': true, 'icon-muted': !canFinishTodo}" fillColor="#2463ea" style="cursor: pointer; margin-right: 12px; color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="finishTodo"></finish-icon>

              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table striped bordered hover responsive :items="todos"
                       select-mode="single"
                       selectable
                       :fields="todoFields"
                       @row-selected="(items) => {currentTodoSelection = items}">
                <template  v-slot:cell(is_finished)="row">
                  <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
                  <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="!row.item.is_finished"></book-open-page-variant-icon>
                  <check-bold-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-else></check-bold-icon>
                </template>
                <template v-slot:cell(hint)="row">
                  <b-button v-if="row.item.hints && row.item.hints.length" variant="success"  class="font-sm" v-on:click="onHints(row.item.hints)">
                      Anzeigen
                      <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                        {{row.item.hints.length}}
                      </b-badge>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
      <b-col md="5" class="mt-3">
        <b-card class="mb-2">
          <b-row style="gap: 10px">
              <b-button v-if="!editMode && canHandle && aufgabe.complete !== 10 && !auftrag.rechnung" variant="success" class="btn-pill font-lg" v-on:click="$refs.finish_task.showDialog(aufgabe.subject, auftrag.modul == 'mm')">
                Fertigstellen
              </b-button>
            <b-button v-if="auftrag.art === 'LS' && aufgabe.complete !== 10 && !auftrag.rechnung" variant="success" class="btn-pill font-lg" v-on:click="printTour">
              Listenausdruck
            </b-button>
              <b-button v-if="aufgabe.complete === 10 && !auftrag.rechnung" variant="success" class="btn-pill font-lg" disabled>
                Fertiggestellt
              </b-button>
              <b-button v-if="auftrag.rechnung" variant="success" class="btn-pill font-lg" disabled>
                Abgerechnet
              </b-button>
              <b-button v-if="editMode" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(true)">
                Speichern
              </b-button>
              <b-button v-if="editMode" variant="warning" class="btn-pill font-lg" v-on:click="toggleEditMode(false)">
                Abbruch
              </b-button>
              <b-button v-if="isEditMode && canHandle && aufgabe.complete !== 10 && !auftrag.rechnung" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(undefined)">
                Ändern
              </b-button>
            <b-button v-if="!editMode && hasTaskSeries && canHandle && aufgabe.complete !== 10 && !auftrag.rechnung && aufgabe.task_series_id === '' && aufgabe.tour_id === '' && auftrag.art === 'AU'" variant="success"
                      class="btn-pill font-lg" v-on:click="$refs.create_task_series_dialog.showModal(bauhofStructure)">
              Serien-Aufgabe anlegen
            </b-button>
              <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
                Zurück
              </b-button>
          </b-row>
        </b-card>
        <b-card v-if="resultingTourTasks.length > 0" class="mb-2">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Aufgaben aus der Tour</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm"
                          @click="createSubTour" :disabled="!hasInside">
                  Vergeben
                </b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="margin: -18px" v-if="resultingTourTasks.length > 0">
            <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container2"
                   ref="map_container2">
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="auftrag.art !== 'LS'" class="mb-2">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Anhänge</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm" @click="$refs.task_attachment_upload.showDialog()" v-if="editMode">
                  Hinzufügen
                </b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-list-group>
                <b-list-group-item
                    button
                    class="d-flex justify-content-between align-items-center"
                    v-for="item in attachments"
                    v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                  {{item.file_name}}
                  <div style="
    align-items: center;
    display: flex;">
                  <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                    {{formatBytes(item.file_size)}}
                  </b-badge>
                  <!--delete-icon v-if="editMode" title="" v-tooltip="'Löschen'"
                               :class="{'icon-1_5x': true}" fillColor="#2463ea"
                               style="cursor: pointer; margin-right: 12px; color: #016d03; margin-left: 4px;margin-bottom: 2px;"
                               :size="72" @click.prevent.stop="onDeleteAttachment(item)"></delete-icon-->
                  </div>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="rooms.length || canHandle" class="mb-2">
          <div slot="header">
            Chats
          </div>
          <b-row style="gap: 10px; margin-top: -12px; margin-bottom: -12px">
            <template v-for="(room, roomId, index) in rooms">
              <task-messaging-button :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben' : 'Auftraggeber'" :new-messages="room.room.unreadCount" @open-chat="showChat = roomId; room.room.unreadCount = 0;"/>
            </template>
            <task-messaging-button name="Weiterleitungen" :is-active="forwards.length > 0" v-if="canHandle && auftrag.art !== 'LS'" @open-chat="openForwards = true;"/>
          </b-row>
        </b-card>
        <b-card v-if="auftrag.art !== 'DE' && auftrag.rechnung" class="mb-2">
          <div slot="header">
            Rechnungen
          </div>
          <b-row>
            <b-col>
              <b-list-group>
                <b-list-group-item
                    button
                    class="d-flex justify-content-between align-items-center"
                    v-for="item in bills"
                    v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                  {{item.file_name}}
                  <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                    {{formatBytes(item.file_size)}}
                  </b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="auftrag.art === 'DE'" class="mb-2">
          <div slot="header">
            Ablehnungs-Nachricht
          </div>
          <b-row>
            <b-col>
              <b-form-textarea id="info-box" ref="infoBox"
                               class="text-black"
                               :placeholder="deleteMessage"
                               rows="6"
                               max-rows="40"
                               :disabled="true"
                               v-model="deleteMessage"

              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="auftrag.notiz_annahme !== null && auftrag.quittung === 'True'" class="mb-2">
          <div slot="header">
            Annahme-Nachricht
          </div>
          <b-row>
            <b-col>
              <b-form-textarea
                  class="text-black"
                  :placeholder="annahmeMessage"
                  rows="6"
                  max-rows="40"
                  wrap="hard"
                  :disabled="true"
                  v-model="annahmeMessage"

              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="auftrag.notiz_fertig !== null && auftrag.offen >= 1" class="mb-2">
          <div slot="header">
            Fertigstellungs-Nachricht ({{formateFertig}})
          </div>
          <b-row>
            <b-col>
              <b-form-textarea
                  class="text-black"
                  :placeholder="fertigMessage"
                  rows="6"
                  max-rows="40"
                  wrap="hard"
                  :disabled="true"
                  v-model="fertigMessage"

              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="(auftrag.lat !== 0.0 && auftrag.lon !== 0.0) || editMode" class="mb-2">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Position</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm"
                          @click="$refs.task_location_map.showMap()" v-if="editMode">
                  Anpassen
                </b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 0" v-if="auftrag.lat !== 0.0 && auftrag.lon !== 0.0">
            <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container"
                   ref="map_container">
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mt-2 mb-2" v-if="auftrag.art === 'LS'">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Aufgabenverteilung:</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm" @click="onChangeTodos" :disabled="aufgabe.complete === 10 || auftrag.rechnung || !canHandle">
                  Verteilung anpassen
                </b-button>
                <finish-icon v-if="aufgabe.complete !== 10 && !auftrag.rechnung && canHandle" title="" v-tooltip="'Fertigstellen'" :class="{'icon-1_5x': true, 'icon-muted': !canFinishTodo}" fillColor="#2463ea" style="cursor: pointer; margin-right: 12px; color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="finishTodo"></finish-icon>

              </b-row>
            </b-col>
            <!--b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
              <b-button variant="success" style="float: right" class="btn-pill font-sm" @click="onChangeTodos" :disabled="aufgabe.complete === 10 || auftrag.rechnung || !canHandle">
                Verteilung anpassen
              </b-button>
            </b-col-->
          </b-row>
          <b-row>
            <b-col>
              <b-table striped bordered hover responsive :items="todos"
                       select-mode="single"
                       selectable
                       :fields="todoFields"
                       @row-selected="(items) => {currentTodoSelection = items}">
                <template  v-slot:cell(is_finished)="row">
                  <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
                  <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="!row.item.is_finished"></book-open-page-variant-icon>
                  <check-bold-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-else></check-bold-icon>
                </template>
                <template v-slot:cell(hint)="row">
                  <b-button v-if="row.item.hints && row.item.hints.length" variant="success"  class="font-sm" v-on:click="onHints(row.item.hints)">
                    Anzeigen
                    <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                      {{row.item.hints.length}}
                    </b-badge>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mt-2 mb-2" v-if="auftrag.art === 'LS' && tourTraces != null && tourTraces.length">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Nachweise:</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table striped bordered hover responsive :items="tourTraces"
                       :fields="traceFields">
                <template v-slot:cell(actions)="row">
                  <b-button variant="success"  class="font-sm" v-on:click="$refs.trace_map.showMap(allTraces[row.item.trace_id], tourTasks)">
                    Anzeigen
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
    <update-todos-dialog ref="update_todos_dialog" @change-todo="(currentPlanning) => {fromAccept = false; $refs.change_todo.showDialog(currentPlanning)}" @todos-updated="onTodosUpdated"/>
    <change-todo-dialog ref="change_todo" @change-todo="(todo) => {if(fromAccept){$refs.accept_dialog.onChangeTodo(todo)}else{$refs.update_todos_dialog.onChangeTodo(todo)}}"></change-todo-dialog>
    <finish-task-dialog ref="finish_task" @finish-task="onFinish"></finish-task-dialog>

    <template v-for="(room, roomId, index) in rooms">
      <task-messaging @chat-active="activateChat" :key="roomId" :room="room.room" :is-second="canHandle && index === 0 || !canHandle && index !== 0" :is-third="canHandle && index !== 0" v-if="showChat === roomId && room.room != null" :last-online="room.lastOnline" @close-chat="showChat = null" @show-group="room.showChatGroup = true" @show-invite="room.showInvite = true" @user-added="addRoomUser" @leave-room="leaveRoom"/>
      <!--task-messaging-footer :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben Chat' : 'Auftraggeber Chat'" :is-second="canHandle && index === 0 || !canHandle && index !== 0" :is-third="canHandle && index !== 0" :new-messages="room.room.unreadCount" v-if="room.room !== null && showChat !== roomId" @open-chat="openForwards = false; showChat = roomId; room.room.unreadCount = 0;"></task-messaging-footer-->
      <task-messaging-users v-if="room.room !== null" :show-group="room.showChatGroup" :users="room.room.users" @hide-group="room.showChatGroup = false"></task-messaging-users>
      <task-messaging-invite @hidden="room.showInvite = false" v-if="room.room != null" :show-invite="room.showInvite" :room="room.room" @hide-invite="room.showInvite = false" @invite-success="(userid) => {room.room.users.push({_id: userid})}"></task-messaging-invite>
    </template>
    <task-share :show-share="showShare" :task-short="taskShort" @share-success="onShared" @forward-open-success="onOpenForwards" @hidden="showShare = false"></task-share>
    <forwards-dialog :forwards="forwards" ref="forwards_dialog" @open-chat="forwardRoom = $event"/>
    <forward-messaging :room="forwardRoom" v-if="forwardRoom != null"  @close-chat="forwardRoom = null" />
    <a-geber-dialog ref="a_geber_dialog" :address-data="addressData" :can-edit="canHandle" :task-id="taskId" @on-changed="onChangedAddress"/>
    <task-forward-messaging ref="task_forward_messaging" :forwards="forwards" v-if="openForwards" @close-chat="openForwards = false" @forward="showShare = true"/>
    <!--task-share-footer :is-active="forwards.length > 0" v-if="canHandle && !openForwards" @open-forwards="showChat = null; openForwards = true;"></task-share-footer-->
    <create-task-series-dialog ref="create_task_series_dialog" :task-date="aufgabe.datum" @create-task-series="createTaskSeries" />

    <b-modal size="m" v-model="showChangeKostMigr" centered title="Verantwortlichkeit anpassen"
    >
      <b-row class="mt-2">
        <b-col>
          <v-jstree ref="js_tree" :allow-transition="false"
                    style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;"
                    class="my-tree" :data="kostMigrs"
                    @item-click="onKostMigrClicked"
                    show-checkbox></v-jstree>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="cancel">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="!selectedKostMigr" variant="success" @click="setKostMigr">
          OK
        </b-button>
      </template>
    </b-modal>
    <b-modal size="lg" v-model="showHintPopup" centered title="Hinweise"
    >
      <b-row>
        <b-col class="pt-1 pb-1">
          <b-table striped bordered responsive :items="currentHints" style="max-height: 50vh; overflow: auto;"
                   :fields="hintFields">
            <template v-slot:cell(message)="row">
              {{row.item.message}}
              <a v-if="row.item.file_name" v-on:click.prevent="onAttachment(row.item.file_name, row.item.task_id, row.item.todo_id)" href="empty">{{row.item.file_name}}</a>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showHintPopup = false">
          Abbrechen
        </b-button>
      </template>
    </b-modal>
    <task-location-map :lat="auftrag.lat" :lon="auftrag.lon" :geo-ref-perimeter="geoRefPerimeter" ref="task_location_map" @save-position="onChangePosition"/>
    <task-attachment-upload ref="task_attachment_upload" @upload-files="uploadFiles"/>
    <select-legr-dialog ref="select_legr" @legr-selected="(legr) => {$refs.accept_dialog.onSetLegr(legr)}"></select-legr-dialog>
    <accept-task-dialog ref="accept_dialog" create-sub-tour :bauhof-structure="bauhofStructure" :auftrag="subTour" :augr-name="augrName"
                        @select-legr="$refs.select_legr.showDialog()"
                        @select-planning="(users) => {$refs.select_plannings.showDialog(users)}"
                        @change-planning="(currentPlanning) => {fromAccept = true; $refs.change_todo.showDialog(currentPlanning)}"
                        @accept-task="onSubTourCreated"
    ></accept-task-dialog>
    <select-planning-dialog ref="select_plannings" @planning-selected="(plannings) => {$refs.accept_dialog.onNewPlanning(plannings)}"></select-planning-dialog>
    <trace-map ref="trace_map"></trace-map>

  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from 'luxon'
import {
  arrayBufferToBase64,
  decryptAES,
  decryptFile,
  decryptMessages,
  decryptTodos,
  encryptAES,
  encryptFile, encryptMultipleAES,
  encryptServerTodos, encryptTodos
} from "../../../shared/crypto";
import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
import AccountBox from 'vue-material-design-icons/AccountBox.vue';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import {Redirect_500, Server_URL} from "@/shared/utils";
import TaskMessaging from "../../messaging/task_messaging.vue"
import TaskMessagingFooter from "@/views/messaging/task_messaging_footer.vue";
import TaskMessagingUsers from "@/views/messaging/task_messaging_user.vue";
import TaskMessagingInvite from "@/views/messaging/task_messaging_invite.vue";
import ForwardMessaging from "@/views/messaging/forward_messaging.vue";
import TaskForwardMessaging from "@/views/messaging/task_forward_messaging.vue";
import ForwardsDialog from "@/views/messaging/task_messaging_forwards_dialog.vue";
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import VJstree from 'vue-jstree'
import UpdateTodosDialog from "@/views/aufgaben_verwaltung/UpdateTodosDialog.vue";
import ChangeTodoDialog from "../../aufgaben_verwaltung/ChangeTodoDialog.vue"
import FinishTaskDialog from "../../aufgaben_verwaltung/FinishTaskDialog.vue"
import TraceMap from "../../aufgaben_verwaltung/TraceMap.vue"
import AGeberDialog from "../../aufgaben_verwaltung/AGeberDialog.vue"
import TaskShare from "@/views/messaging/task_messaging_share.vue";
import TaskShareFooter from "@/views/messaging/task_forwards_footer.vue";
import TaskMessagingButton from "@/views/messaging/task_messaging_button.vue";

import SelectLegrDialog from "../../aufgaben_verwaltung/SelectLegrDialog.vue"
import AcceptTaskDialog from "../../aufgaben_verwaltung/AcceptTaskDialog.vue"
import SelectPlanningDialog from "../../aufgaben_verwaltung/SelectPlanningDialog.vue"


import FinishIcon from 'vue-material-design-icons/CheckCircle.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';




import { doc, onSnapshot } from "firebase/firestore";
import {firestoreDb} from "@/shared/firebase";
import {listenMessageCounter, PARTICIPANT_PATH} from "@/shared/firebase/database";
import CreateTaskSeriesDialog from "@/views/aufgaben_verwaltung/CreateTaskSeriesDialog.vue";
import TourTable from "@/views/auftraege/auftrag/TourTable.vue";
import TaskLocationMap from "@/views/auftraege/auftrag/TaskLocationMap.vue";
import TaskAttachmentUpload from "@/views/auftraege/auftrag/TaskAttachmentUpload.vue";

import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
require('../../../shared/free_draw');


export default {
  name: "auftrag",
  components: {
    TaskAttachmentUpload,
    TaskLocationMap,
    TourTable,
    CreateTaskSeriesDialog,
    AccountMultiplePlusIcon,
    AccountBox,
    TaskMessaging,
    TaskMessagingFooter,
    TaskMessagingUsers,
    TaskMessagingInvite,
    BookOpenPageVariantIcon,
    CheckBoldIcon,
    VJstree,
    UpdateTodosDialog,
    ChangeTodoDialog,
    FinishTaskDialog,
    TaskShare,
    ForwardsDialog,
    ForwardMessaging,
    AGeberDialog,
    TaskForwardMessaging,
    TaskShareFooter,
    TaskMessagingButton,
    FinishIcon,
    DeleteIcon,
    SelectLegrDialog,
    AcceptTaskDialog,
    SelectPlanningDialog,
    TraceMap
  },
  computed: {
    canFinishTodo() {
      return this.currentTodoSelection.length && !this.currentTodoSelection[0].is_finished;
    },
    isAuftrag() {
      let splits = this.aufgabe.auftrag_key.split(".");
      if (this.auftrag.art === 'LS') {
        return 'Tour'
      } else if (splits.length === 3 && splits[2] !== "") {
        return "Auftrag:";
      } else {
        return "Aufgabe:";
      }
    },
    isEditMode() {
      return !this.editMode;
    },
    shouldShoudFinish() {
      return this.showFinish && this.canFinish;
    },
    a_nr() {
      let base = this.auftrag.gi_augr + " / " + this.auftrag.gi_aufisn;
      if (this.auftrag.art === "DE") {
        return base;
      }
      return base + (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "" ? " (" + this.auftrag.notiz_annahme + ")" : "");
    },
    formateDate() {
      if (this.auftrag.datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateAnlageDate() {
      if (this.auftrag.datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateFertig() {
      if (this.auftrag.fertig_datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.fertig_datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateAugr() {
      return this.auftrag.gi_augr + " " + this.augrName;
    },
    formateAuftragKey() {
      let splits = this.aufgabe.auftrag_key.split(".");
      if (splits.length === 2 || (splits.length === 3 && splits[2] === "")) {
        return splits[1]
      } else {
        return splits[1] + "." + splits[2]
      }
    },
    formateAusfDurch() {
      let postfix = "Kostenstelle"
      if (this.aufgabe.ausf_durch_typ === "MIGR") {
        postfix = "Mitarbeitergruppe"
      }
      return this.aufgabe.ausf_durch + " (" + postfix + ")"
    },
    formateAhnehmerUser() {
      if (this.auftrag.a_nehmer_user === "" || this.auftrag.a_nehmer_user === "auto") {
        return "Automatische Annahme";
      } else {
        let res = JSON.parse(sessionStorage.getItem(this.auftrag.a_nehmer_user));
        if (res === null) {
          return this.auftrag.a_nehmer_user;
        }
        return res.first_name + " " + res.surname;
      }
    }
  },
  props:{
    onFileClicked: {
      type: Function,
      default: undefined
    },
    onFileOk: {
      type: Function,
      default: undefined
    },
    onAttachment: {
      type: Function,
      default: undefined
    },
    responseError: {
      type: Function,
      default: undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    showFinish: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      currentTodoSelection: [],
      showChatGroup: false,
      showChat: null,
      showInvite: false,
      room: null,
      rooms: {},
      attachments: [],
      bills: [],
      numberMessages: 0,
      canHandle: false,
      kostMigrs: [],
      selectedKostMigr: null,
      showChangeKostMigr: false,
      bauhofStructure: [],
      auftrag: {
        id: "testid",
        a_nehmer: "Bauhof",
        auftraggeber: "Musterhausen-Public Solutions",
        ziel: "26.01.2019",
        ziel_datum: LuxonDateTime.fromJSDate(new Date()).toISO(),
        gi_hh_aus: "9300300.55511010.2-85500",
        beleg_ex: "2019-0001",
        gi_auf_ext: "Test Sven",
        gi_match: "Forstwirtschaft",
        gi_augr: "0009",
        gi_aufisn: "000038",
        gi_memo: "Test vom Sven",
        email: "info@publicsolutions.de",
        datum: "",
        sachbearbeiter: "Administrator",
        offen: 0,
        quittung: null
      },
      aufgabe: {
        auftrag_key: "",
        ausf_durch: "",
        ausf_durch_typ: "",
      },
      augrName: "",
      deleteMessage: "",
      fertigMessage: "",
      finishMessageMmDefault: "Ihre Kommune meldet, dass der von Ihnen gemeldete Mangel nun behoben ist.\nVielen Dank für Ihre Mithilfe.",
      annahmeMessage: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      maxrows: 40,
      editMode: false,
      textBackup: undefined,
      dateBackup: undefined,
      aufExtBackup: undefined,
      massnahmeBackup: undefined,
      materialBackup: undefined,
      ausfuhrTypeBackup: undefined,
      ausfuhrBackup: undefined,
      delete_modal: false,
      freigabe: false,
      deletable: false,
      userId: "",

      interval: null,
      listeners: {},
      lastOnline: null,
      // chat specific
      hasChat: false,
      url: "",
      download: "",
      filename: "",
      a_nehmer: "Bauhof",
      hasContact: false,
      contact: "",
      canFinish: false,
      todos: [],
      close_automatic: false,
      close_automatic_select: [{text: "Manuelle Fertigstellung", value: false}, {text: "Automatische Fertigstellung", value: true}],
      hintFields: [
        {key: 'create_date', label:"Datum", formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let event = new Date(value.replace('Z',''));
            let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return event.toLocaleDateString('de-DE', options);
          }},
        {key: 'user_id', label:"Meldung von"},
        {key: 'message', label:"Nachricht"},
      ],
      todoFields: [
        {key: 'is_finished', label: 'Status'},
        {key: 'user_id', label:"Zuweisung", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            if (item.name !== "") {
              return item.name;
            }
            let res = JSON.parse(sessionStorage.getItem(item.user_id));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }},
        {key: 'till', label:"Termin", formatter: 'dateToString'},
        {key: 'message', label: "Aufgabenbeschreibung", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = item.message;
            let n = 50;
            return (res.length > n) ? res.slice(0, n-1) + '...' : res;
          }},
        {key: 'hint', label: 'Hinweise'}
      ],
      traceFields: [
        {key: 'start', label:"Datum", formatter: 'dateToString'},
        {key: 'mita', label:"Mitarbeiter", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = JSON.parse(sessionStorage.getItem(item.mita));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }},
        {key: 'end', label: "Dauer", formatter: (value, key, item) => {
            let start = new Date(item.start.replace('Z',''));
            let end = new Date(item.end.replace('Z',''));
            let duration = (end.getTime() - start.getTime()) / 60000;
            let hours = Math.floor(duration / 60);
            let minutes = Math.floor(duration%60);
            return hours + "," + minutes.toString().padStart(2, '0') + " Stunden";
          }},
        {key: 'actions', label: ''}
      ],
      canShare: false,
      showShare: false,
      taskShort: {
        id: "",
        title: "",
        description:"",
        where:"",
        from:"",
        till:"",
      },
      currentHints: [],
      showHintPopup: false,
      forwards: [],
      openForwards: false,
      forwardRoom: null,
      addressData: {
        gi_anrede: '',
        gi_name1: '',
        gi_name2: '',
        gi_strasse: '',
        gi_plz: '',
        gi_ort: '',

        re_anrede: '',
        renr: '',
        re_vorname: '',
        re_name1: '',
        re_str_hnr: '',
        re_land: '',
        re_plz: '',
        re_ort: '',
      },
      einzel: null,
      taskId: "",
      tourTasks: [],
      hasSelects: false,
      isBauhof: false,
      geoRefPerimeter: "",
      files: [],
      hasTaskSeries: false,
      resultingTourTasks: [],
      hasInside: false,
      insideTourTasks: [],
      taskPredef: null,
      fromAccept: false,
      subTour: {
        gi_auf_ext: "",
      },
      tourTraces: [],
      allTraces: {},
    }
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
  },
  beforeDestroy: function () {
    for (const property in this.listeners) {
      this.listeners[property].forEach(listener => listener())
      this.listeners[property] = []
    }
  },
  methods: {
    onSubTourCreated(req) {
      req.gi_aufisn = this.insideTourTasks[0].aufisn;
      req.resulting_tour_tasks = this.insideTourTasks;
      this.showLoader();
      encryptMultipleAES(sessionStorage.getItem("aes"), [req.gi_memo]).then(res => {
        req.gi_memo = res[0];
        req.key = sessionStorage.getItem("aes");
        if (req.todos && req.todos.length) {
          encryptTodos(sessionStorage.getItem("aes"), req.todos).then(res => {
            req.todos = res;
            this.$http.post(
                Server_URL+'/auftragsbuch/data/plan_resulting_tour_tasks/' + this.auftrag.id,
                req,
            ).then(this.responseOkReload, this.responseError)
          }).catch(res => {
            console.log(res)
          })
        } else {
          this.$http.post(
              Server_URL+'/auftragsbuch/data/plan_resulting_tour_tasks/' + this.auftrag.id,
              req,
          ).then(this.responseOkReload, this.responseError);
        }
      }).catch(res => {
        console.log(res);
      })
    },
    createSubTour() {
      this.subTour.gi_auf_ext = this.taskPredef.resulting_task_name;
      this.$refs.accept_dialog.showDialog(null, false);
    },
    onDeleteAttachment(item) {
      this.showLoader();
      this.$http.delete(
          Server_URL + '/auftragsbuch/data/av/delete_attachment/'+this.auftrag.id+"?attachmentId=" + item.id
      ).then(this.responseOkTrap, this.responseError)
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].id === item.id) {
          this.attachments.splice(i, 1);
          return;
        }
      }
    },
    uploadFiles(files) {
      if (files.length > 0) {
        this.files = files;
        this.showLoader();
        this.uploadFile();
      }
    },
    uploadFile() {
      if (this.files.length !== 0) {
        let file = this.files.pop();
        if (sessionStorage.getItem("aes") !== null) {
          const reader = new FileReader();
          reader.addEventListener('load', (event) => {
            let buf = new Uint8Array(event.target.result);
            encryptFile(sessionStorage.getItem("aes"), buf).then(res => {
              const b = new Blob([res], {type: file.type});
              let formData = new FormData();
              formData.append('upload_file', b, file.name);
              formData.append('key', sessionStorage.getItem("aes"))
              this.$http.post(Server_URL + '/auftragsbuch/upload/file/'
                  +this.auftrag.id + "?file_type=A",
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
              ).then(this.responseUploadOk, this.responseError)
            }).catch(err => {
              console.log(err);
              this.hideLoader();
            })
          });
          reader.readAsArrayBuffer(file);
        }
      }
    },
    responseUploadOk(response) {
      if (response.status === 200 && response.body.status === "ok") {
        if (this.files.length === 0) {
          this.responseOkReload()
        } else {
          this.uploadFile();
        }
      } else {
        window.location = Redirect_500;
      }
    },

    onChangePosition({lat, lon}) {
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/data/av/edit_position/'+this.auftrag.id, {lat: lat, lon: lon, key: sessionStorage.getItem("aes")}
      ).then(this.responseOkTrap, this.responseError)
      this.auftrag.lat = lat;
      this.auftrag.lon = lon;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
    printTour() {
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/tour/print/'+this.auftrag.id, {}, {responseType: 'blob'}
      ).then(this.responsePrintTour, this.responseError)
    },
    responsePrintTour(response) {
      this.hideLoader();
      response.blob().then(blob => {
        if (!this.isBauhof) {
          console.log(blob)
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        } else {
          blob.arrayBuffer().then(binary => {
            try {
              windowsFileService.onFile(
                  arrayBufferToBase64(new Uint8Array(binary)),
                  "AufgabenListe_" + (new Date()).getTime() + ".pdf", // todo add timestamp to name
                  blob.type
              ).then(r => {
                if (r && !r.Success) {
                  console.log(r)
                }
              }).catch(e => {
                console.log(e)
              });
            } catch (e) {
              console.log(e);
            }
          })
        }
      });
    },
    finishTourTasks() {
      this.showLoader();
      let ids = [];
      let selection = this.$refs.auftraegeTable.selectedItems();
      for (let i = 0; i < selection.length; i++) {
        ids.push(selection[i].id);
      }
      encryptAES(sessionStorage.getItem("aes"), "").then(res => {
        let req = {
          finish_message: res,
          finish_message_plain: "",
          ids: ids,
        }
        this.$http.post(
            Server_URL + '/auftragsbuch/data/av/finish', req
        ).then(() => {
          this.hideLoader();
          for (let i = 0; i < this.tourTasks.length; i++) {
            for (let j = 0; j < ids.length; j++) {
              if (this.tourTasks[i].id === ids[j]) {
                this.tourTasks[i].complete = 10;
                this.tourTasks[i].completed = "something";
                this.tourTasks[i].count_finished = this.tourTasks[i].count_finished + this.tourTasks[i].count_open;
                this.tourTasks[i].count_open = 0;
                break;
              }
            }
          }
          this.$refs.auftraegeTable.toggleAll(false)
        }, this.responseError)
      }).catch(e => {
        console.log(e)
        this.hideLoader();
      })
    },
    finishTourTask({id}) {
      console.log({id})
      this.showLoader();
      encryptAES(sessionStorage.getItem("aes"), "").then(res => {
        let req = {
          finish_message: res,
          finish_message_plain: "",
        }
        this.$http.post(
            Server_URL + '/auftragsbuch/data/av/finish/' + id, req
        ).then(() => {
          this.hideLoader();
          for (let i = 0; i < this.tourTasks.length; i++) {
            if (this.tourTasks[i].id === id) {
              this.tourTasks[i].complete = 10;
              this.tourTasks[i].completed = "something";
              this.tourTasks[i].count_finished = this.tourTasks[i].count_finished + this.tourTasks[i].count_open;
              this.tourTasks[i].count_open = 0;
              break;
            }
          }
          this.$refs.auftraegeTable.toggleAll(false)
        }, this.responseError)
      }).catch(e => {
        console.log(e)
        this.hideLoader();
      })
    },
    finishTodo() {
      if (!this.currentTodoSelection.length || this.currentTodoSelection[0].is_finished) {
        return
      }
      for (let i = 0; i < this.todos.length; i++) {
        if (this.todos[i].id === this.currentTodoSelection[0].id) {
          this.todos[i].is_finished = true;
          break
        }
      }
      this.currentTodoSelection[0].is_finished = true;
      this.$http.post(
          Server_URL + '/auftragsbuch/data/av/finish_todo/' + this.currentTodoSelection[0].id
      ).then(this.responseOkTrap, this.responseError)
    },
    createTaskSeries(payload) {
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/task_series/'+this.auftrag.id,
          payload).then(this.responseTaskSeriesOk, this.responseError);
      this.aufgabe.task_series_id = "set";
    },
    responseTaskSeriesOk() {
      this.hideLoader();
      this.$bvToast.toast("Die Aufgabenserie wurde erfolgreich erstellt.\nBitte beachten Sie, dass die Erstellung der einzelnen Aufgaben noch etwas Zeit in Anspruch nehmen kann.", {
        title: 'Aufgabenserie erstellt',
        autoHideDelay: 5000,
        appendToast: false,
        toaster: 'b-toaster-top-center',
      })
    },
    activateChat(roomId) {
      this.rooms[roomId].room.is_active = true;
      if (this.listeners[roomId] === null || this.listeners[roomId] === undefined || this.listeners[roomId].length === 0) {
        this.startListener(roomId, this.userId)
      }
    },
    onChangedAddress(data) {
      this.einzel.salutation = data.a_geber_data.gi_anrede;
      this.einzel.name_1 = data.a_geber_data.gi_name1;
      this.einzel.name_2 = data.a_geber_data.gi_name2;
      this.einzel.street = data.a_geber_data.gi_strasse;
      this.einzel.zip_code = data.a_geber_data.gi_plz;
      this.einzel.city = data.a_geber_data.gi_ort;

      this.einzel.re_anrede = data.invoice_data.re_anrede;
      this.einzel.re_nr = data.invoice_data.renr;
      this.einzel.re_vorname = data.invoice_data.re_vorname;
      this.einzel.re_name_1 = data.invoice_data.re_name1;
      this.einzel.re_strh_nr = data.invoice_data.re_str_hnr;
      this.einzel.re_land = data.invoice_data.re_land;
      this.einzel.re_plz = data.invoice_data.re_plz;
      this.einzel.re_ort = data.invoice_data.re_ort;
    },
    showAddressModal() {
      this.taskId = this.auftrag.id;
        this.addressData.gi_anrede = this.einzel.salutation;
        this.addressData.gi_name1 = this.einzel.name_1;
        this.addressData.gi_name2 = this.einzel.name_2;
        this.addressData.gi_strasse = this.einzel.street;
        this.addressData.gi_plz = this.einzel.zip_code;
        this.addressData.gi_ort = this.einzel.city;

        this.addressData.re_anrede = this.einzel.re_anrede;
        this.addressData.renr = this.einzel.re_nr;
        this.addressData.re_vorname = this.einzel.re_vorname;
        this.addressData.re_name1 = this.einzel.re_name_1;
        this.addressData.re_str_hnr = this.einzel.re_strh_nr;
        this.addressData.re_land = this.einzel.re_land;
        this.addressData.re_plz = this.einzel.re_plz;
        this.addressData.re_ort = this.einzel.re_ort;

      this.$refs.a_geber_dialog.showModal();
    },
    onOpenForwards(data) {
      this.showShare = false;
      this.forwards = data;
      if (this.forwards.length === 1) {
        this.forwardRoom = this.forwards[0];
      } else {
        this.$refs.forwards_dialog.showModal();
      }
    },
    onShared(room) {
      this.showShare = false;
      /*this.$bvToast.toast("Die Aufgabe wurde erfolgreich weitergeleitet.", {
        title: 'Weitergeleitet',
        autoHideDelay: 3000,
        appendToast: false,
        toaster: 'b-toaster-top-center',
      })*/
      this.forwards.unshift(room);
      this.$refs.task_forward_messaging.forwardRoom = room;
    },
    async onHints(hints) {
      this.currentHints = JSON.parse(JSON.stringify(hints))
      for (let i = 0; i < this.currentHints.length; i++) {
        if (this.currentHints[i].message !== "") {
          try {
            this.currentHints[i].message = await decryptAES(sessionStorage.getItem("aes"), this.currentHints[i].message);
          } catch (e) {
            console.log(e)
          }
        }
        let res = JSON.parse(sessionStorage.getItem(this.currentHints[i].user_id));
        if (res !== null) {
          this.currentHints[i].user_id = res.full_name;
        }
      }
      this.showHintPopup = true;
    },
    onShare() {
      this.showShare = true;
    },
    onTodosUpdated(res) {
      this.showLoader();
      res.key = sessionStorage.getItem("aes");
      encryptServerTodos(res.key, res.todos).then(r => {
        res.todos = r;
        this.$http.post(
            Server_URL + '/auftragsbuch/data/av/todos/'+this.auftrag.id,
            res
        ).then(this.onTodoResponseOk, this.responseError)
      }).catch(e => {
        console.log(e)
      })
    },
    setKostMigr() {
      let ausType = "KOST";
      if (this.selectedKostMigr.node_type === "migr") {
        ausType = "MIGR"
      }
      this.aufgabe.ausf_durch_typ = ausType;
      this.aufgabe.ausf_durch = this.selectedKostMigr.text;
      this.showChangeKostMigr = false;
    },
    onKostMigrClicked(node, item, e) {
      this.selectedKostMigr = item;
    },
    computeKostMigrs(data) {
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    onChangeTodos() {
      this.$refs.update_todos_dialog.showDialog(this.bauhofStructure, this.todos, this.aufgabe.description, this.auftrag.id, this.aufgabe.subject)
    },
    print() {
      this.$htmlToPaper('auftrag1', () => {
      });
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    toggleEditMode(save) {
      if (save === undefined) {
        this.textBackup = this.aufgabe.description;
        this.dateBackup = this.aufgabe.datum;
        this.aufExtBackup = this.aufgabe.auftrag_was;
        this.massnahmeBackup =  this.aufgabe.massnahme;
        this.materialBackup = this.aufgabe.materialtext;
        this.ausfuhrTypeBackup = this.aufgabe.ausf_durch_typ;
        this.ausfuhrBackup = this.aufgabe.ausf_durch;
      } else if (save === false) {
        this.aufgabe.description = this.textBackup;
        this.aufgabe.datum = this.dateBackup;
        this.aufgabe.auftrag_was = this.aufExtBackup;
        this.aufgabe.massnahme = this.massnahmeBackup;
        this.aufgabe.materialtext = this.materialBackup;
        this.aufgabe.ausf_durch_typ = this.ausfuhrTypeBackup;
        this.aufgabe.ausf_durch = this.ausfuhrBackup;
        this.close_automatic = this.auftrag.aufgabe === "Y";
      } else {
        this.showLoader();
        let req = {
          description: this.aufgabe.description,
          ziel_datum: this.aufgabe.datum,
          auftrag_was: this.aufgabe.auftrag_was,
          massnahme: this.aufgabe.massnahme,
          materialtext: this.aufgabe.materialtext,
          ausf_durch_typ: this.aufgabe.ausf_durch_typ,
          ausf_durch: this.aufgabe.ausf_durch,
          close_automatic: this.close_automatic,
          key: sessionStorage.getItem("aes"),
        }
        encryptAES(sessionStorage.getItem("aes"), req.description).then(res => {
          req.description = res;
          this.$http.post(
              Server_URL + '/auftragsbuch/data/av/edit/'+this.auftrag.id,
              req
          ).then(this.onEditResponseOk, this.responseError)
        })
      }
      this.editMode = !this.editMode;
    },
    onEditResponseOk(response) {
      this.hideLoader();
      if (response.status === 200) {
      } else {
        window.location = Redirect_500;
      }
    },
    onTodoResponseOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        let todos = response.body;
        decryptTodos(sessionStorage.getItem("aes"), todos).then(res => {
          this.todos = res;
        }).catch(e => {
          console.log(e);
          this.todos = todos;
        })
        this.hideLoader();
      } else {
        window.location = Redirect_500;
      }
    },
    onFinish(message) {
      this.aufgabe.complete = 10;
      this.auftrag.fertig_datum = new Date().toISOString();
      this.fertigMessage = message;
      this.auftrag.notiz_fertig = "";
      this.auftrag.offen = 2;
      // set todos to finished
      for (let i = 0; i < this.todos.length; i++) {
        this.todos[i].is_finished = true;
      }
      for (let i = 0; i < this.tourTasks.length; i++) {
          this.tourTasks[i].complete = 10;
          this.tourTasks[i].completed = "something";
          this.tourTasks[i].count_finished = this.tourTasks[i].count_finished + this.tourTasks[i].count_open;
          this.tourTasks[i].count_open = 0;
      }
      this.showLoader();
      encryptAES(sessionStorage.getItem("aes"), message).then(res => {
        let req = {
          finish_message: res,
          finish_message_plain: message,
        }
        this.$http.post(
            Server_URL + '/auftragsbuch/data/av/finish/' + this.auftrag.id, req
        ).then(this.responseOkTrap, this.responseError)
      }).catch(e => {
        // todo catch
      })
    },
    async responseOkFetch(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.userId = response.body.session.id;
        let data = response.body.data;
        console.log(data)
        this.canShare = this.$cookies.get("ps_customer_number") === "8888810" || this.$cookies.get("ps_customer_number") === "7678986";
        await this.decryptTourData(data.tour_tasks);
        if (sessionStorage.getItem("aes") !== null) {
          this.decryptData(data.data.gi_memo, data.data.notiz_annahme,
              data.data.notiz_fertig,
              data.data.art, data.aufgabe.description, data.todos).then(res => {
            data.data.gi_memo = res[0];
            data.data.notiz_annahme = res[1];
            data.data.notiz_fertig = res[2];
            data.aufgabe.description = res[3];
            data.todos = res[4];
            this.setData(data);
          }).catch(e => {
            this.setData(data);
          });
        } else {
          this.setData(data);
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async decryptTourData(data) {
      if (data === null || data === undefined) {
        return;
      }
      for (let i = 0; i < data.length; i++) {
        data[i]._showDetails = true;
        data[i].selected = false;
        data[i]._rowVariant = '';
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      this.tourTasks = data;
      /*this.$refs.auftraegeTable.allSelected = false;
      this.$refs.auftraegeTable.indeterminate = false;
      this.hasSelects = false;*/
    },
    async decryptData(memo, annahme, fertig, art, desc, todos) {
      try {
        if (memo !== null && memo !== "") {
          memo = await decryptAES(sessionStorage.getItem("aes"), memo);
        }
      } catch (e) {
      }
      try {
        if (desc !== null && desc !== "") {
          desc = await decryptAES(sessionStorage.getItem("aes"), desc);
        }
      } catch (e) {
      }
      try {
        todos = await decryptTodos(sessionStorage.getItem("aes"), todos)
      } catch (e) {
      }
      try {
        if (annahme !== null && annahme !== "") {
          annahme = await decryptAES(sessionStorage.getItem("aes"), annahme);
        }
      } catch (e) {
      }
      try {
        if (fertig !== null && fertig !== "") {
          fertig = await decryptAES(sessionStorage.getItem("aes"), fertig);
        }
      } catch (e) {
      }
      return [memo, annahme, fertig, desc, todos]
    },
    setData(data) {
      this.auftrag = data.data;
      this.aufgabe = data.aufgabe;
      this.einzel = data.einzel;
      if (data.resulting_task_tour_tasks) {
        this.resultingTourTasks = data.resulting_task_tour_tasks;
      }
      this.taskPredef = data.task_predef;
      this.tourTraces = data.traces;
      this.allTraces = data.trace_map;
      this.geoRefPerimeter = data.geo_ref_perimeter;
      this.forwards = data.forwarded_rooms;
      this.augrName = data.augr_name;
      this.allGroups = data.all_groups;
      this.bauhofStructure = data.bauhof_structure;
      this.kostMigrs = this.computeKostMigrs(JSON.parse(JSON.stringify(data.bauhof_structure)));
      this.hideLoader();
      this.todos = data.todos;
      this.hasTaskSeries = data.has_task_series;
      this.contact = "";
      this.close_automatic = this.auftrag.aufgabe === "Y";
      this.canHandle = data.can_handle;
      if (this.auftrag.modul === "mm") {
        let defectData = JSON.parse(this.auftrag.custom_properties);
        let hasContact = defectData.name !== "" || defectData.email !== "" || defectData.phone_number !== "";
        if (hasContact) {
          if (defectData.name !== "") {
            this.contact += "Name: " + defectData.name + "\n"
          }
          if (defectData.email !== "") {
            this.contact += "Email: " + defectData.email + "\n"
          }
          if (defectData.phone_number !== "") {
            this.contact += "Tel: " + defectData.phone_number + "\n"
          }
        }
      }
      this.hasContact = this.contact !== "";
      this.editMode = false;
      this.canFinish = true;

      if (this.auftrag.art === "DE") {
        this.canFinish = false;
        this.disableChat = true;
        this.deleteMessage = this.auftrag.notiz_annahme;
        this.messagePlaceholder = "Der Auftrag ist abgelehnt."
      }
      if (this.auftrag.offen >= 1) {
        this.canFinish = false;
        this.disableChat = true;
        this.messagePlaceholder = "Der Auftrag ist abgeschlossen."
      }
      if (this.auftrag.notiz_fertig !== null && this.auftrag.notiz_fertig !== "") {
        this.fertigMessage = this.auftrag.notiz_fertig;
      }
      if (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "") {
        this.annahmeMessage = this.auftrag.notiz_annahme;
      }
      let res = JSON.parse(sessionStorage.getItem(this.auftrag.auftraggeber));
      if (res !== null) {
        this.auftrag.auftraggeber = res.username;
      }
      if (this.auftrag.auftraggeber in this.allGroups) {
        this.auftrag.auftraggeber = this.allGroups[this.auftrag.auftraggeber];
      }

      if (this.auftrag.modul === "bk") {
        this.auftrag.auftraggeber = "Baumkontrolle";
      } else if (this.auftrag.modul === "k1") {
        this.auftrag.auftraggeber = "Spielplatzkontrolle";
      } else if (this.auftrag.modul === "k2" || this.auftrag.modul === "k4") {
        this.auftrag.auftraggeber = "GPS-Nachweis";
      } else if (this.auftrag.modul === "k3") {
        this.auftrag.auftraggeber = "Straßenkontrolle";
      } else if (this.auftrag.modul === "k5") {
        this.auftrag.auftraggeber = "Fast-Task";
      }

      this.taskShort.id = this.auftrag.id;
      this.taskShort.from =this.auftrag.auftraggeber;
      this.taskShort.title =this.aufgabe.auftrag_was;
      this.taskShort.description =this.aufgabe.description;
      this.taskShort.where =this.aufgabe.auftrag_wo;
      this.taskShort.till =this.formateDate;

      res = JSON.parse(sessionStorage.getItem(this.auftrag.sachbearbeiter));
      if (res !== null) {
        this.auftrag.sachbearbeiter = res.first_name + " " + res.surname;
        this.auftrag.email = res.email;
      }
      this.$nextTick(() => {
        this.showMapIfNeeded();
        this.showTourTasksMapIfNeeded();
      });
      this.attachments = data.attachments;
      this.bills = data.rechnungen;
      this.deletable = data.settings.use_delete;
      if (data.settings.fg_stufe1 && this.auftrag.art === "FG" && this.auftrag.freigabe1 === "-") {
        this.freigabe = data.user_settings.do_freigabe || this.auftrag.freigeber === data.user_settings.login;
      }
      this.hasChat = data.has_chat && this.auftrag.art !== "SO";
      if (this.hasChat) {
        if (this.hasChat && data.chat_room.roomId !== "") {
          data.chat_room.unreadCount = 0;
          this.$set(this.rooms, data.chat_room.roomId,
              {
                room: data.chat_room,
                showChatGroup: false,
                showChat: false,
                showInvite: false,
                lastOnline: null,
              })
          this.listeners[data.chat_room.roomId] = [];
          //this.room = data.chat_room;
          if (this.rooms[data.chat_room.roomId].room.is_active
              && !this.rooms[data.chat_room.roomId].room.is_archived) {
            let found = false;
            for (let i = 0; i < this.rooms[data.chat_room.roomId].room.users.length; i++) {
              if (this.rooms[data.chat_room.roomId].room.users[i]._id === this.userId) {
                found = true;
                break;
              }
            }
            if (found) {
              this.startListener(data.chat_room.roomId, this.$cookies.get("ps_user_id"));
            }
          }
          if (this.$route.query.open_chat === "task") {
            this.showChat = data.chat_room.roomId;
          }
        }
        if (this.hasChat && data.chat_room_internal.roomId !== "") {
          data.chat_room_internal.unreadCount = 0;
          this.$set(this.rooms, data.chat_room_internal.roomId,
              {
                room: data.chat_room_internal,
                showChatGroup: false,
                showChat: false,
                showInvite: false,
                lastOnline: null,
              })
          this.listeners[data.chat_room_internal.roomId] = [];
          //this.room = data.chat_room;
          if (this.rooms[data.chat_room_internal.roomId].room.is_active
              && !this.rooms[data.chat_room_internal.roomId].room.is_archived) {
            let found = false;
            for (let i = 0; i < this.rooms[data.chat_room_internal.roomId].room.users.length; i++) {
              if (this.rooms[data.chat_room_internal.roomId].room.users[i]._id === this.userId) {
                found = true;
                break;
              }
            }
            if (found) {
              this.startListener(data.chat_room_internal.roomId, this.$cookies.get("ps_user_id"));
            }
            if (this.$route.query.open_chat === "int") {
              this.showChat = data.chat_room_internal.roomId;
            }
          }
        }
      }
    },
    addRoomUser(roomId, u) {
      let found = false;
      for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
        if (this.rooms[roomId].room.users[i]._id === u) {
          found = true;
          break;
        }
      }
      if (!found) {
        this.rooms[roomId].room.users.push({_id: u,  username: ""})
        if (this.userId === u) {
          this.startListener(roomId, u)
        }
      }
    },
    leaveRoom(roomId) {
      for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
        if (this.rooms[roomId].room.users[i]._id === this.userId) {
          this.rooms[roomId].room.users.splice(i, 1);
          break;
        }
      }
      this.listeners[roomId].forEach(listener => listener());
      this.listeners[roomId] = [];
    },
    startListener(roomId, userId) {
      if (userId === this.$cookies.get("ps_user_id")) {
        if (this.listeners[roomId]) {
          this.listeners[roomId].forEach(listener => listener());
        }
        this.listeners[roomId] = [];
        const unsub = listenMessageCounter(this.$cookies.get("ps_customer_number"),
            this.rooms[roomId].room.roomId,
            this.$cookies.get("ps_user_id"),
            (data) => {
              this.rooms[roomId].room.unreadCount = data.count_unread;
              this.rooms[roomId].lastOnline = data.last_active.toDate();
            });
        this.listeners[roomId].push(unsub)
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    back() {
      window.history.back();
    },
    responseErrorTrap(response) {
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        console.log(response);
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseOkReload() {
      this.$http.get(
          Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
      ).then(this.responseOkFetch, this.responseError)
    },
    showMapIfNeeded() {
      if (this.auftrag.lat === 0.0 || this.auftrag.lon === 0.0) {
        return;
      } else if (this.map !== undefined) {
        this.marker.setLngLat([this.auftrag.lon, this.auftrag.lat])
        this.map.flyTo({
          center: [this.auftrag.lon, this.auftrag.lat]
        });
        return;
      }

      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        center: [this.auftrag.lon, this.auftrag.lat],
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

      this.marker = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    mapLoad() {
      setTimeout(() => {
        if (this.marker === null) {
          let el = document.createElement('div');
          el.className = 'marker';

          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.auftrag.lon, this.auftrag.lat])
              .addTo(this.map);
        }
        this.map.resize();
        this.hideLoader()
      });
    },

    showTourTasksMapIfNeeded() {
      if (this.resultingTourTasks.length === 0 || this.map2 !== undefined ) {
        return;
      }
      let bounds = new (mapboxgl.LngLatBounds);
      for (let i = 0; i < this.resultingTourTasks.length; i++) {
        if (this.resultingTourTasks[i].lat === 0 || this.resultingTourTasks[i].lon === 0) {
          continue;
        }
        bounds.extend(new mapboxgl.LngLat(this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat));
      }

      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map2 = new mapboxgl.Map({
        container: 'map_container2',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        bounds: bounds,
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });
      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      });
      this.map2.addControl(this.draw, 'top-left');
      this.map2.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map2.addControl(languageControl);
      this.markers = null;
      this.geojson = {};
      this.map2.on('load', this.mapLoad2);
    },
    onAreaUpdated(e) {
      let polygons = this.draw.getAll();
      this.hasInside = false;
      this.insideTourTasks = [];
      if (polygons.length === 0) {
        this.drawMarkers();
      } else {
        this.removeMarkers();
        for (let i = 0; i < this.resultingTourTasks.length; i++) {
          let isInside = false;
          for (let j = 0; j < polygons.features.length; j++) {
            if (booleanPointInPolygon([this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat], polygons.features[j])) {
              isInside = true;
              this.hasInside = true;
              this.insideTourTasks.push(this.resultingTourTasks[i]);
              break;
            }
          }
          let el = document.createElement('div');
          el.className = isInside ? 'marker_selected' : 'marker';
          el.id = this.resultingTourTasks[i].id;


          let marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat])
              .setPopup(new mapboxgl.Popup({ offset: 25 }).setText(
                  this.resultingTourTasks[i].name
              ))
              .addTo(this.map2);
          marker.id = this.resultingTourTasks[i].id;
          marker.isSelected = isInside;
          this.markers.push(marker);
        }
      }
    },
    removeMarkers() {
      if (this.markers === null || this.markers.length === 0) {
        this.markers = [];
        return;
      }
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].remove();
      }
      this.markers = [];
    },
    drawMarkers() {
      this.removeMarkers()
      for (let i = 0; i < this.resultingTourTasks.length; i++) {
        let el = document.createElement('div');
        el.className = 'marker';
        el.id = this.resultingTourTasks[i].id;
        //el.addEventListener('click', this.onMarkerClicked);

        let marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
            .setLngLat([this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat])
            .setPopup(new mapboxgl.Popup({ offset: 25 }).setText(
                this.resultingTourTasks[i].name
            ))
            .addTo(this.map2);
        marker.id = this.resultingTourTasks[i].id;
        this.markers.push(marker);
      }
    },
    mapLoad2() {
      setTimeout(() => {
        if (this.markers === null) {
          this.onAreaUpdated();
          this.map2.on('draw.create', this.onAreaUpdated);
          this.map2.on('draw.delete', this.onAreaUpdated);
          this.map2.on('draw.update', this.onAreaUpdated);
        }
        this.map2.resize();
      });
    },
  }
}
</script>

<style>

.marker {
  background-image: url('../../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}
.marker_selected {
  background-image: url('../../../../public/marker_selected.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.sc-message {
  width: 480px;
}

.sc-message--text .sc-message--toolbox {
  display: none;
}

.sc-launcher.opened :before {
  box-shadow: none;
}

.sc-launcher.opened:before {
  box-shadow: none !important;
}

.sc-chat-window {
  border: 1px solid lightgray !important;
  width: 520px !important;
  z-index: 5;
}

.sc-launcher {
  z-index: 5;
}

.sc-header {
  min-height: unset !important;
}

.sc-user-input {
  border-top: 1px solid lightgray !important;

}

.sc-user-input--text {
  width: 450px !important;
}

.sc-header--close-button {
  margin-left: 0 !important;
}

.my-body {
  padding: 0 !important;
}

.hidden_header {
  display: none;
}

.sc-user-input--file-icon-wrapper {
  margin-bottom: 0;
}
</style>

<style scoped>

.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.p-center {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0;
}

.bold-text {
  font-weight: bold;
}

::placeholder { /* Firefox, Chrome, Opera */
  color: black;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}

.icon-muted {
  cursor: initial !important;
  opacity: 0.3 !important;
}

</style>
